/**
 * UnsavedChangesBanner Component
 * Displays amber alert when form has unsaved changes
 * 
 * Used in both Information and Preview tabs to indicate pending changes
 */

import { AlertCircle } from 'lucide-react';

/**
 * Unsaved Changes Banner Component
 * Shows amber warning banner when form has unsaved changes
 */
export function UnsavedChangesBanner() {
  return (
    <div 
      className="mb-6 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3"
      role="alert"
      aria-live="polite"
    >
      <AlertCircle className="h-5 w-5 flex-shrink-0 text-amber-600 mt-0.5" />
      <div className="flex-1">
        <h4 className="text-sm font-semibold text-amber-900">
          You have unsaved changes
        </h4>
        <p className="mt-1 text-sm text-amber-800">
          Preview shows current form state. Click "Save" to persist changes.
        </p>
      </div>
    </div>
  );
}

